import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

import AccessibleViewDefaultTemplate, { defaultUsableNet } from './config.js';
import * as styles from './Button.css';

const cx = classNames.bind(styles);

export const Button = ({ AccessibleView, isNative, usableNet }) => {
    const { scriptId = defaultUsableNet.scriptId, scriptUrl = defaultUsableNet.scriptUrl } =
        usableNet || defaultUsableNet;
    useEffect(() => {
        const existingScript = document.getElementById(scriptId);

        if (!existingScript) {
            const script = document.createElement('script');
            script.defer = true;
            script.id = scriptId;
            script.src = scriptUrl;
            document.head.appendChild(script);
        }
    }, [usableNet]);

    const buttonStyles = dt(['text-black', 'text-small', 'underline']);
    const onUsableNetAnchorClicked = () => {
        /* istanbul ignore next */
        if (typeof window !== 'undefined' && window.enableUsableNetAssistive) {
            window.enableUsableNetAssistive();
        }
    };

    if (isNative || !AccessibleView) return null;

    return (
        <a
            id="header-accessible-view"
            data-automation-id="accessible-view"
            className={`UsableNetAssistive ${cx('accessibleView', buttonStyles)}`}
            onClick={onUsableNetAnchorClicked}
            href="#"
            title="By activating this link you will enable accessibility for all the data and features of the site"
            dangerouslySetInnerHTML={{ __html: AccessibleView.name }}
            suppressHydrationWarning
        />
    );
};

Button.propTypes = {
    AccessibleView: PropTypes.object,
    isNative: PropTypes.bool,
    usableNet: PropTypes.object,
};

Button.defaultProps = {
    AccessibleView: {},
    isNative: false,
    usableNet: {},
};

const mapStateToProps = (state) => ({
    AccessibleView: get(state, 'context.preferences.AccessibleView', AccessibleViewDefaultTemplate),
    isNative: get(state, 'context.isNative', false),
    usableNet: get(state, 'context.preferences.usableNet', {}),
});

export default connect(mapStateToProps)(Button);
